import { useSelector } from "react-redux";

export const useCertificationText = formType => {
	const certificationTexts = useSelector(state => state?.tenant?.certificationTexts) ?? {};

	return formType in certificationTexts ? certificationTexts[formType] : {};
};

export default useCertificationText;
